import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { ThemeProvider } from 'next-themes';
import { Toaster } from 'sonner';
import { Navigation } from './components/Navigation';
import { ExploreActivities } from './components/ExploreActivity';
import { ComingSoon } from './components/ComingSoon';
import { MapView } from './components/MapView';
import { Settings } from './components/Settings';
import { AuthPage } from './components/AuthPage';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ActivityDetailPage } from './components/ActivityDetailPage';
import { CreatorProfilePage } from './components/CreatorProfilePage';
import { MyActivities } from './components/MyActivities';
import { ApplicationManagement } from './components/ApplicationManagement';
import { ActivityManagement } from './components/ActivityManagement';
import { CreateActivityWizard } from './components/CreateActivityWizard';
import { AuthSuccess } from "./components/AuthSuccess";
import { AuthError } from "./components/AuthError";
import { EmailVerifyErrorPage } from "./components/EmailVerifyErrorPage";
import { LandingPage } from "./components/LandingPage";


interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <div> Loading... </div>
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
    // return (
    //   <AuthPage onLogin={() => { }} />
    // );
  }
  return <>{children}</>;
}

const AppContent: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  const routes = [
    { path: '/explore', element: <ExploreActivities />, protected: true },
    // { path: '/coming-soon', element: <ComingSoon />, protected: true },
    { path: '/coming-soon', element: <MyActivities />, protected: true },
    { path: '/create-activity', element: <CreateActivityWizard />, protected: true },
    // { path: '/manage-applications', element: <ApplicationManagement />, protected: true },
    { path: '/activity-management', element: <ActivityManagement />, protected: true },
    { path: '/map', element: <MapView />, protected: true },
    { path: '/settings', element: <Settings />, protected: true },
    { path: '/activity/:id', element: <ActivityDetailPage />, protected: true },
    { path: '/creator/:creatorId', element: <CreatorProfilePage />, protected: true },
    { path: '/auth/success', element: <AuthSuccess />, protected: true },
    { path: '/auth/error', element: <AuthError />, protected: false },
    { path: '/auth/email-verify-error', element: <EmailVerifyErrorPage />, protected: false },
    { path: '/', element: <LandingPage onLogin={() => navigate('/login')} onSignUp={() => navigate('/signup')} />, protected: false },
    // { path: '*', element: <Navigate to="/explore" replace />, protected: false },
    // TODO: add a page not found page

    { path: '/login', element: <AuthPage />, protected: false },
    { path: '/signup', element: <AuthPage />, protected: false },
  ]

  return (
    <div className="min-h-screen bg-background bg-gradient-subtle bg-glow-orbs relative overflow-x-hidden">
      {/* Subtle dot grid pattern overlay */}
      <div className="fixed inset-0 bg-grid-pattern opacity-[0.4] dark:opacity-[0.5] pointer-events-none" />
      <Navigation />
      <main className="pt-16 relative">
        <Routes>
          {routes.map((route) => (
            <Route key={route.path} path={route.path} element={route.protected ? <ProtectedRoute>{route.element}</ProtectedRoute>
              : route.element} />
          ))}
        </Routes>
      </main>
    </div>
  )
}

export default function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <AuthProvider>
        <Router>
          <AppContent />
          <Toaster />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}
